/*****************************************
 * UI constants
 *****************************************/

export const uiData = {
  // select example text
  selectOptions: ["צורות", "אותיות", "כלבים", "שיווק", "חידה"],

  svgViewBox: `0 0 800 400`,
};

/*****************************************
 * Examples constants and global variables
 *****************************************/

const data = {
  examples: [
    {
      headerText: "צורות גיאומטריות פשוטות",
      subHeaderText: ["כיצד עוברים מעיגול לריבוע ומריבוע לכוכב וחוזר חלילה ?"],

      sliderData: {
        minTimeScale: 0.5,
        maxTimeScale: 4,
        stepTimeScale: 0.5,
        initTimeScale: 1,
      },
      speed: 5,
      viewBox: "0 0 800 400",
    },
    {
      headerText: "אותיות",
      subHeaderText: [" מעבר מרקד בין מילים"],
      sliderData: {
        minTimeScale: 0.5,
        maxTimeScale: 4,
        stepTimeScale: 0.5,
        initTimeScale: 1,
      },
      speed: 2,
      viewBox: "0 0 800 400",
    },
    {
      headerText: "כלבים",
      subHeaderText: ["שינוי צורות עגלגלות"],
      sliderData: {
        minTimeScale: 0.5,
        maxTimeScale: 3,
        stepTimeScale: 0.5,
        initTimeScale: 1,
      },
      speed: 1,
      viewBox: "-50 0 200 100",
    },
    {
      headerText: "שיווק",
      subHeaderText: ["דוגמה לשימוש במצגת שיווקית (לקוחה מספריית האנימציה)"],
      sliderData: {
        minTimeScale: 0.5,
        maxTimeScale: 4,
        stepTimeScale: 0.5,
        initTimeScale: 1,
      },
      speed: 3,
      viewBox: "-200 0 800 400",
    },
    {
      headerText: "חידת העפיפון",
      // subHeaderText: ['גודל התחלתי:', '32x32 px', 'גודל סופי:', '320x320 px'],
      subHeaderText: [
        "נוכל לשלוט בצורת האנימציה באמצעות הגדרת שתי נקודות – שחורה ואדומה. נסו ללכוד את הנקודות בעכבר ולהזיזן. חקרו: כיצד מיקומן משפיע על צורת האנימציה? מתי יש סימטריה? איזה מיקום נראה לכם הכי מגניב? ",
      ],

      sliderData: {
        minTimeScale: 0.5,
        maxTimeScale: 4,
        stepTimeScale: 0.5,
        initTimeScale: 1,
      },
      speed: 5,
      viewBox: "0 0 800 400",
    },
  ],

  /*****************************************
   * Global variables
   *****************************************/

  exampleIdx: 0,
  lastExampleIdx: -1,
};

export default data;
